var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSunrise(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.233,
    height: 19.043,
    viewBox: "0 0 20.233 19.043",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.638,120.554a17.224,17.224,0,0,0-2.362.163,7.341,7.341,0,0,0-14.319,0A16.98,16.98,0,0,0,.6,120.554H0v9.521H20.233v-9.521Zm-9.521-4.364a6.148,6.148,0,0,1,5.985,4.731,17.181,17.181,0,0,0-5.577,2.246l-.457.286L9.7,123.21l-.01-.007a16.922,16.922,0,0,0-5.562-2.277,6.148,6.148,0,0,1,5.986-4.736Zm-8.926,12.7v-7.13A15.726,15.726,0,0,1,9.048,124.2l7.035,4.681Zm9.965-4.708a15.987,15.987,0,0,1,7.887-2.422v7.13h-.812Z",
    transform: "translate(0 -111.033)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240,15h1.19v2.777H240Z",
    transform: "translate(-230.479 -15)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H1.19V2.777H0Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 4.047, 1.786)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H1.19V2.777H0Z",
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 0.199, 6.07)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H2.777V1.19H0Z",
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 17.034, 6.427)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H2.777V1.19H0Z",
    transform: "matrix(0.5, -0.866, 0.866, 0.5, 13.767, 3.596)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunrise);
export default __webpack_public_path__ + "static/media/sunrise.2721fa53c7d711eb00f6f6494a28c043.svg";
export { ForwardRef as ReactComponent };